// ----------------------------------------------------------------------------
// Component: Video Block
// ----------------------------------------------------------------------------
//
// Content component that positions a video in a custom-sized block, or in
// the flex-position or flex-grid.
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';
import 'snippets/video-player/video-block'

// Styles
import './_video-block.scss';
